import { takeEvery, put, select } from 'redux-saga/effects';

import employeesActions from '../actionTypes/employeesActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { ADD_NEW_EMPLOYEE, UPDATE_EMPLOYEE_DETAILS, EMPLOYEE_UPDATE_PROFILE } from '../routes';

const getCompanyId = (state) => {
  return state.loginReducer.currentUser.resourceable_id;
};

function* addNewEmployee({ payload }) {
  const id = yield select(getCompanyId);
  yield put({
    type: API_CALL,
    payload: {
      url: ADD_NEW_EMPLOYEE.replace(':company_id', id),
      method: 'POST',
      data: payload,
    },
    successAction: employeesActions.addNewEmployeeSuccess,
    failureAction: employeesActions.addNewEmployeeFailed,
  });
}

function* updateEmployee({ payload }) {
  const id = yield select(getCompanyId);
  const { userId } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: UPDATE_EMPLOYEE_DETAILS.replace(':company_id', id).replace(
        ':id',
        userId
      ),
      method: 'PATCH',
      data: payload,
    },
    successAction: employeesActions.updateEmployeeDetailsSuccess,
    failureAction: employeesActions.updateEmployeeDetailsFailed,
  });
}

function* employeeProfileUpdate({ payload }) {
  const { id, user } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: EMPLOYEE_UPDATE_PROFILE.replace(':id', id),
      method: 'PATCH',
      data: { user },
    },
    successAction: employeesActions.employeeProfileUpdateSuccess,
    failureAction: employeesActions.employeeProfileUpdateFailed,
  });
}

export default function* watchEmployee() {
  yield takeEvery(employeesActions.addNewEmployee, addNewEmployee);
  yield takeEvery(employeesActions.updateEmployeeDetails, updateEmployee);
  yield takeEvery(employeesActions.employeeProfileUpdate, employeeProfileUpdate);
}
